(function () {
  'use strict';

  function extractQty(label) {
    if (!label) return 1;
    var str = String(label).trim();
    var m = str.match(/(\d+)\s*(?:sheet|pc|piece|unit|item|pack|nos)/i) ||
            str.match(/(?:pack\s*of|qty|quantity)\s*:?\s*(\d+)/i) ||
            str.match(/^(\d+)$/);
    if (m) return parseInt(m[1], 10) || 1;
    if (/\b\d+\s*x\s*\d+/i.test(str)) return 1;
    var fallback = str.match(/(\d+)/);
    return fallback ? (parseInt(fallback[1], 10) || 1) : 1;
  }

  function formatMoney(amount) {
    var n = Number(amount) || 0;
    return '₹' + n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function formatFileSize(bytes) {
    if (!bytes || bytes === 0) return '0 B';
    var k = 1024;
    var sizes = ['B', 'KB', 'MB', 'GB'];
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
  }

  function selectedOption(select) {
    if (select.selectedOptions && select.selectedOptions.length) return select.selectedOptions[0];
    return select.options[select.selectedIndex] || null;
  }

  function triggerShake(element) {
    if (!element) return;
    element.classList.remove('ppc__shake');
    void element.offsetWidth; // Force DOM reflow to re-trigger keyframe
    element.classList.add('ppc__shake');
    setTimeout(function () {
      element.classList.remove('ppc__shake');
    }, 650);
  }

  function initPhotoFlow(root, data) {
    var variants = data.variants || [];
    var maxFileMb = data.maxFileMb || 10;
    var cartAddUrl = data.cartAddUrl || '/cart/add.js';

    var summaryQtyEls = root.querySelectorAll('.ppc__summary-qty');
    var summaryPriceEls = root.querySelectorAll('.ppc__summary-price');
    var errorEl = root.querySelector('.ppc__error');
    var statusEl = root.querySelector('.ppc__status');
    var submitBtn = root.querySelector('.ppc__add-to-cart');
    var dropzoneBox = root.querySelector('#ppc-photo-dropzone-' + root.id.replace('ppc-', ''));
    var photoFileInput = root.querySelector('.ppc__photo-file-input');
    var photoFileNameEl = root.querySelector('#ppc-photo-file-name-' + root.id.replace('ppc-', ''));
    var photoUploadedCard = root.querySelector('#ppc-photo-uploaded-card-' + root.id.replace('ppc-', ''));
    var photoThumb = root.querySelector('#ppc-photo-uploaded-thumb-' + root.id.replace('ppc-', ''));
    var photoRemoveBtn = root.querySelector('#ppc-photo-remove-' + root.id.replace('ppc-', ''));
    var notes = root.querySelector('.ppc__notes');
    var selects = root.querySelectorAll('.ppc__photo-select');
    var photoFile = null;

    function findMatchingVariant() {
      var chosen = [];
      selects.forEach(function (s) {
        chosen[parseInt(s.getAttribute('data-option-index'), 10)] = s.value;
      });
      return variants.find(function (v) {
        return (chosen[0] === undefined || v.option1 === chosen[0]) &&
               (chosen[1] === undefined || v.option2 === chosen[1]) &&
               (chosen[2] === undefined || v.option3 === chosen[2]);
      });
    }

    function update() {
      var variant = findMatchingVariant();
      var price = variant ? variant.price / 100 : 0;
      summaryQtyEls.forEach(function (el) { el.textContent = variant ? '1' : '0'; });
      summaryPriceEls.forEach(function (el) { el.textContent = formatMoney(price); });

      var message = '';
      if (!variant) message = 'Choose all options above.';
      else if (!photoFile) message = 'Upload a reference photo.';

      if (errorEl) errorEl.textContent = '';
      if (submitBtn) {
        submitBtn.setAttribute('aria-disabled', !!message ? 'true' : 'false');
        submitBtn.classList.toggle('is-disabled', !!message);
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', update); });

    function handlePhotoFile(file) {
      if (!file) {
        photoFile = null;
        if (photoFileInput) photoFileInput.value = '';
        if (photoUploadedCard) photoUploadedCard.hidden = true;
        if (dropzoneBox) dropzoneBox.hidden = false;
        update();
        return;
      }

      if (file.size > maxFileMb * 1024 * 1024) {
        if (errorEl) errorEl.textContent = file.name + ' exceeds maximum allowed size of ' + maxFileMb + 'MB.';
        handlePhotoFile(null);
        return;
      }

      photoFile = file;
      if (photoFileNameEl) photoFileNameEl.textContent = file.name + ' (' + formatFileSize(file.size) + ')';
      if (dropzoneBox) dropzoneBox.hidden = true;
      if (photoUploadedCard) photoUploadedCard.hidden = false;

      if (/\.(png|jpe?g|gif|webp)$/i.test(file.name) && photoThumb) {
        var reader = new FileReader();
        reader.onload = function (e) {
          photoThumb.src = e.target.result;
          photoThumb.hidden = false;
        };
        reader.readAsDataURL(file);
      } else if (photoThumb) {
        photoThumb.hidden = true;
      }

      update();
    }

    if (photoFileInput) {
      photoFileInput.addEventListener('change', function () {
        var file = photoFileInput.files && photoFileInput.files[0];
        handlePhotoFile(file);
      });
    }

    if (photoRemoveBtn) {
      photoRemoveBtn.addEventListener('click', function () {
        handlePhotoFile(null);
      });
    }

    if (dropzoneBox) {
      ['dragenter', 'dragover'].forEach(function (eventName) {
        dropzoneBox.addEventListener(eventName, function (e) {
          e.preventDefault();
          dropzoneBox.classList.add('is-dragover');
        });
      });
      ['dragleave', 'drop'].forEach(function (eventName) {
        dropzoneBox.addEventListener(eventName, function (e) {
          e.preventDefault();
          dropzoneBox.classList.remove('is-dragover');
        });
      });
      dropzoneBox.addEventListener('drop', function (e) {
        var dt = e.dataTransfer;
        var files = dt && dt.files;
        if (files && files.length) {
          handlePhotoFile(files[0]);
        }
      });
    }

    async function submitPhotoOrder() {
      triggerShake(submitBtn);
      var variant = findMatchingVariant();
      if (!variant) {
        if (errorEl) {
          errorEl.textContent = 'Please choose all options above.';
          triggerShake(errorEl);
        }
        return;
      }
      if (!photoFile) {
        if (errorEl) {
          errorEl.textContent = 'Please upload a reference photo.';
          triggerShake(errorEl);
        }
        return;
      }

      submitBtn.disabled = true;
      statusEl.textContent = 'Adding to cart…';

      try {
        var formData = new FormData();
        formData.append('id', variant.id);
        formData.append('quantity', 1);
        formData.append('properties[Reference Photo]', photoFile, photoFile.name);
        if (notes && notes.value.trim()) formData.append('properties[Order Notes]', notes.value.trim());

        var res = await fetch(cartAddUrl, { method: 'POST', body: formData });
        if (!res.ok) throw new Error('Failed to add to cart');

        statusEl.textContent = 'Added to cart!';
        if (typeof ajaxCart !== 'undefined' && typeof ajaxCart.load === 'function') {
          try { ajaxCart.load(); } catch (e) {}
        }
        if (window.dTGeneral && typeof window.dTGeneral.showMiniCart === 'function') {
          try {
            if (typeof window.dTGeneral.closeMiniCart === 'function') window.dTGeneral.closeMiniCart();
            window.dTGeneral.showMiniCart();
          } catch (e) {}
        }
      } catch (err) {
        statusEl.textContent = '';
        errorEl.textContent = 'Something went wrong adding this to your cart. Please try again.';
      } finally {
        submitBtn.disabled = false;
      }
    }

    if (submitBtn) submitBtn.addEventListener('click', submitPhotoOrder);

    var waBtn = root.querySelector('.ppc__whatsapp-btn');
    if (waBtn) {
      waBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var rawPhone = waBtn.getAttribute('data-phone') || '9211537151';
        var cleanPhone = rawPhone.replace(/\D/g, '');
        if (cleanPhone.length === 10) cleanPhone = '91' + cleanPhone;
        if (!cleanPhone) cleanPhone = '919211537151';

        var greeting = waBtn.getAttribute('data-greeting') || 'Hello My Print Warrior, I would like to order:';
        var productTitle = waBtn.getAttribute('data-product-title') || document.title;
        var variant = findMatchingVariant();
        var price = variant ? variant.price / 100 : 0;
        var noteVal = notes && notes.value ? notes.value.trim() : '';

        var msgParts = [greeting, '', '📦 *Product:* ' + productTitle];
        if (variant && variant.title && variant.title.indexOf('Default') === -1) {
          msgParts.push('🏷️ *Selected Options:* ' + variant.title);
        }
        if (price > 0) {
          msgParts.push('💰 *Price:* ' + formatMoney(price));
        }
        if (photoFile) {
          msgParts.push('📎 *Reference Photo:* ' + photoFile.name + ' (attached in this chat)');
        }
        if (noteVal) {
          msgParts.push('📝 *Notes:* ' + noteVal);
        }
        msgParts.push('', '🔗 *Link:* ' + window.location.href);
        msgParts.push('', 'Please let me know how to proceed with the customized order!');

        var waUrl = 'https://api.whatsapp.com/send?phone=' + cleanPhone + '&text=' + encodeURIComponent(msgParts.join('\n'));
        window.open(waUrl, '_blank');
      });
    }

    update();
  }

  function initPPC(root) {
    var dataEl = root.nextElementSibling;
    if (!dataEl || dataEl.tagName !== 'SCRIPT') return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    if (root.getAttribute('data-config-type') === 'photo') {
      initPhotoFlow(root, data);
      return;
    }

    var variants = data.variants || [];
    var quantityOptionIndex = data.quantityOptionIndex;
    var colourOptionIndex = data.colourOptionIndex;
    var sizeOptionIndex = data.sizeOptionIndex;
    var colourImages = data.colourImages || {};
    var printAreas = data.printAreas || {};
    var maxFileMb = data.maxFileMb || 15;
    var cartAddUrl = data.cartAddUrl || '/cart/add.js';

    var mainImage = root.querySelector('.ppc__gallery-main-img');
    var previewStage = root.querySelector('.ppc__preview-stage');
    var summaryQtyEls = root.querySelectorAll('.ppc__summary-qty');
    var summaryPriceEls = root.querySelectorAll('.ppc__summary-price');
    var errorEl = root.querySelector('.ppc__error');
    var statusEl = root.querySelector('.ppc__status');
    var submitBtn = root.querySelector('.ppc__add-to-cart');
    var notes = root.querySelector('.ppc__notes');

    var rows = root.querySelectorAll('.ppc__colour-row, .ppc__size-row');
    var uploadedFiles = {}; // position -> File
    var activePositions = {}; // position -> bool
    var rowFiles = {}; // colour/size name -> File (DTF: one design per row)
    var rowPreviewUrls = {}; // colour/size name -> data URL of its uploaded design
    var activeRowColour = null;

    function variantOptionAt(variant, index) {
      if (index === 0) return variant.option1;
      if (index === 1) return variant.option2;
      if (index === 2) return variant.option3;
      return null;
    }

    function variantsForRow(row) {
      var colourName = row.getAttribute('data-colour');
      var sizeName = row.getAttribute('data-size');
      return variants.filter(function (v) {
        if (colourOptionIndex >= 0 && colourName !== null && variantOptionAt(v, colourOptionIndex) !== colourName) return false;
        if (sizeName !== null && sizeOptionIndex >= 0 && variantOptionAt(v, sizeOptionIndex) !== sizeName) return false;
        return true;
      });
    }

    var activeRowColour = null;
    var rowFiles = {}; // colourName -> File
    var rowPreviewUrls = {}; // colourName -> dataUrl
    var artworkMode = 'shared';
    var masterFile = null;
    var masterPreviewUrl = null;

    var unitSingular = root.getAttribute('data-unit-singular') || 'Pc';
    var unitPlural = root.getAttribute('data-unit-plural') || (unitSingular + 's');
    var unitLower = unitSingular.toLowerCase();
    var unitPluralLower = unitPlural.toLowerCase();
    var unitText = unitPluralLower;

    var modeSelector = root.querySelector('.ppc__artwork-mode-selector');
    var masterUploadBox = root.querySelector('.ppc__master-upload');
    var coloursDtfContainer = root.querySelector('.ppc__colours--dtf');

    if (modeSelector) {
      modeSelector.querySelectorAll('.ppc__mode-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var mode = btn.getAttribute('data-mode');
          artworkMode = mode;
          modeSelector.querySelectorAll('.ppc__mode-btn').forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
          });
          if (coloursDtfContainer) {
            coloursDtfContainer.setAttribute('data-artwork-mode', mode);
            coloursDtfContainer.classList.toggle('ppc__colours--minimized', mode === 'shared');
          }
          if (masterUploadBox) {
            masterUploadBox.style.display = (mode === 'shared') ? 'block' : 'none';
          }
          validate();
        });
      });
    }

    // Master File Upload handlers
    var masterFileInput = root.querySelector('.ppc__master-file-input');
    var masterDropzone = root.querySelector('.ppc__master-dropzone-label');
    var masterUploadedCard = root.querySelector('.ppc__master-uploaded-card');
    var masterThumbEl = root.querySelector('.ppc__master-file-thumb');
    var masterNameEl = root.querySelector('.ppc__master-file-name');
    var masterChangeBtn = root.querySelector('.ppc__master-change-btn');
    var masterRemoveBtn = root.querySelector('.ppc__master-remove-btn');

    function handleMasterFile(file) {
      if (!file) {
        masterFile = null;
        masterPreviewUrl = null;
        if (masterFileInput) masterFileInput.value = '';
        if (masterNameEl) masterNameEl.textContent = '';
        if (masterThumbEl) { masterThumbEl.style.display = 'none'; masterThumbEl.src = ''; }
        if (masterUploadedCard) masterUploadedCard.hidden = true;
        if (masterDropzone) masterDropzone.hidden = false;
        validate();
        return;
      }

      if (file.size > maxFileMb * 1024 * 1024) {
        if (errorEl) errorEl.textContent = file.name + ' exceeds max allowed size of ' + maxFileMb + 'MB.';
        handleMasterFile(null);
        return;
      }

      masterFile = file;
      if (masterNameEl) masterNameEl.textContent = file.name + ' (' + formatFileSize(file.size) + ')';
      if (masterDropzone) masterDropzone.hidden = true;
      if (masterUploadedCard) masterUploadedCard.hidden = false;

      if (/\.(png|jpe?g|gif|webp)$/i.test(file.name)) {
        var reader = new FileReader();
        reader.onload = function (e) {
          masterPreviewUrl = e.target.result;
          if (masterThumbEl) { masterThumbEl.src = e.target.result; masterThumbEl.style.display = 'block'; }
          if (mainImage) mainImage.src = e.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        masterPreviewUrl = null;
        if (masterThumbEl) { masterThumbEl.style.display = 'none'; masterThumbEl.src = ''; }
      }

      validate();
    }

    if (masterFileInput) {
      masterFileInput.addEventListener('change', function () {
        var f = masterFileInput.files && masterFileInput.files[0];
        handleMasterFile(f);
      });
    }
    if (masterChangeBtn && masterFileInput) {
      masterChangeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        masterFileInput.click();
      });
    }
    if (masterRemoveBtn) {
      masterRemoveBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        handleMasterFile(null);
      });
    }
    if (masterDropzone) {
      ['dragenter', 'dragover'].forEach(function (eventName) {
        masterDropzone.addEventListener(eventName, function (e) {
          e.preventDefault();
          masterDropzone.classList.add('is-dragover');
        });
      });
      ['dragleave', 'drop'].forEach(function (eventName) {
        masterDropzone.addEventListener(eventName, function (e) {
          e.preventDefault();
          masterDropzone.classList.remove('is-dragover');
        });
      });
      masterDropzone.addEventListener('drop', function (e) {
        var dt = e.dataTransfer;
        var files = dt && dt.files;
        if (files && files.length) {
          handleMasterFile(files[0]);
        }
      });
    }

    function tierLabel(variant) {
      if (quantityOptionIndex !== null && quantityOptionIndex !== undefined && quantityOptionIndex >= 0) {
        return variantOptionAt(variant, quantityOptionIndex);
      }
      return '1';
    }

    function getTierPriceForRow(row, rowVariants, enteredQty) {
      // 1. Direct inspection from rendered select options
      var select = row ? row.querySelector('.ppc__qty-select') : null;
      var unitPrice = 0;
      var variantId = 0;
      // bundleQty = how many physical pieces the chosen base variant actually represents
      // (e.g. a "2 Pcs Sample" tier is 1 variant unit = 2 pieces). Custom-quantity math
      // must add whole multiples of this to the cart, since Shopify charges
      // variant.price * cart line quantity — it has no concept of "per piece".
      var bundleQty = 1;

      if (select) {
        var opts = select.querySelectorAll('option[data-qty]');
        var oneOpt = null;
        var minOpt = null;
        var minOptQty = Infinity;

        opts.forEach(function (opt) {
          var q = parseInt(opt.getAttribute('data-qty'), 10) || 0;
          var p = parseFloat(opt.getAttribute('data-price')) || 0;
          if (q === 1) {
            oneOpt = opt;
          }
          if (q > 0 && q < minOptQty) {
            minOptQty = q;
            minOpt = opt;
          }
        });

        if (oneOpt) {
          unitPrice = parseFloat(oneOpt.getAttribute('data-price')) || 0;
          variantId = parseInt(oneOpt.value, 10) || 0;
          bundleQty = 1;
        } else if (minOpt && minOptQty > 0 && minOptQty !== Infinity) {
          var minP = parseFloat(minOpt.getAttribute('data-price')) || 0;
          unitPrice = minP / minOptQty;
          variantId = parseInt(minOpt.value, 10) || 0;
          bundleQty = minOptQty;
        }
      }

      // 2. Fallback to rowVariants array inspection
      if (!unitPrice && rowVariants && rowVariants.length) {
        var oneQtyVariant = null;
        var minQtyVariant = null;
        var minVariantQty = Infinity;
        for (var i = 0; i < rowVariants.length; i++) {
          var v = rowVariants[i];
          if (!v.available) continue;
          var label = tierLabel(v);
          var q = extractQty(label);
          if (q === 1) {
            oneQtyVariant = v;
            break;
          }
          if (q > 0 && q < minVariantQty) {
            minVariantQty = q;
            minQtyVariant = v;
          }
        }
        var chosenVariant = oneQtyVariant || minQtyVariant || rowVariants[0];
        var chosenQty = oneQtyVariant ? 1 : (minQtyVariant ? minVariantQty : (extractQty(tierLabel(chosenVariant)) || 1));
        unitPrice = chosenVariant ? (chosenVariant.price / 100 / chosenQty) : 0;
        variantId = chosenVariant ? chosenVariant.id : 0;
        bundleQty = chosenQty;
      }

      return {
        minQty: 1,
        unitPrice: unitPrice,
        variantId: variantId,
        bundleQty: bundleQty
      };
    }

    // Custom-quantity input must round up to a whole multiple of the base variant's
    // bundle size, otherwise the cart quantity (in bundles) can't exactly represent it.
    function effectiveCustomQty(customQty, bundleQty) {
      if (bundleQty > 1) {
        return Math.ceil(customQty / bundleQty) * bundleQty;
      }
      return customQty;
    }

    function bindCustomInput(row) {
      var customInput = row.querySelector('.ppc__custom-qty-input');
      if (customInput) {
        customInput.oninput = function () {
          updateSummary();
        };
        customInput.onkeyup = function () {
          updateSummary();
        };
        customInput.onchange = function () {
          updateSummary();
        };
      }
    }

    // Populate quantity selects
    rows.forEach(function (row) {
      var select = row.querySelector('.ppc__qty-select');
      var customBox = row.querySelector('.ppc__custom-qty-box');
      var rowVariants = variantsForRow(row);

      rowVariants.forEach(function (v) {
        if (!v.available) return;
        var label = tierLabel(v);
        var qty = extractQty(label);
        var price = v.price / 100;
        var opt = document.createElement('option');
        opt.value = String(v.id);
        opt.setAttribute('data-qty', String(qty));
        opt.setAttribute('data-price', String(price));
        var unitName = (qty === 1) ? unitSingular : unitPlural;
        if (qty > 1) {
          opt.textContent = qty + ' ' + unitName + ' — ' + formatMoney(price) + ' (' + formatMoney(price / qty) + '/' + unitLower + ')';
        } else {
          opt.textContent = qty + ' ' + unitName + ' — ' + formatMoney(price);
        }
        select.appendChild(opt);
      });

      // Add Custom Quantity Option
      var customOpt = document.createElement('option');
      customOpt.value = 'custom';
      customOpt.textContent = '✏️ Custom Quantity';
      select.appendChild(customOpt);

      if (!customBox) {
        customBox = document.createElement('div');
        customBox.className = 'ppc__custom-qty-box';
        customBox.style.setProperty('display', 'none', 'important');
        customBox.innerHTML = '<input type="number" class="ppc__custom-qty-input" min="1" max="10000" placeholder="10" value="10">' +
          '<span class="ppc__custom-qty-unit">' + unitPluralLower + '</span>' +
          '<button type="button" class="ppc__cqty-close" title="Switch back to preset dropdown">✕</button>';
        var selectWrap = row.querySelector('.ppc__select-wrapper');
        if (selectWrap) {
          selectWrap.appendChild(customBox);
        }
      } else {
        customBox.style.setProperty('display', 'none', 'important');
      }

      bindCustomInput(row);
    });

    // Default selection: select 2 pcs/units on the first interactive row so price is not 0
    var defaultRow = rows[0];
    if (defaultRow) {
      var firstSelect = defaultRow.querySelector('.ppc__qty-select');
      if (firstSelect) {
        var opt2 = firstSelect.querySelector('option[data-qty="2"]');
        if (!opt2) {
          var allTierOpts = Array.prototype.slice.call(firstSelect.querySelectorAll('option[data-qty]')).filter(function (o) {
            return (parseInt(o.getAttribute('data-qty'), 10) || 0) > 0;
          });
          if (allTierOpts.length > 0) opt2 = allTierOpts[0];
        }
        if (opt2) {
          firstSelect.value = opt2.value;
          var cName = defaultRow.getAttribute('data-colour');
          if (cName) setActiveRow(cName);
          toggleRowUpload(defaultRow);
        }
      }
    }

    // Capture-phase document-level listeners to guarantee zero missed events
    document.addEventListener('input', function (e) {
      var input = (e.target && e.target.classList && e.target.classList.contains('ppc__custom-qty-input')) ? e.target : (e.target && e.target.closest ? e.target.closest('.ppc__custom-qty-input') : null);
      if (input) {
        var row = input.closest('.ppc__colour-row, .ppc__dtf-card');
        if (row) {
          var select = row.querySelector('.ppc__qty-select');
          var selectWrap = row.querySelector('.ppc__select-wrapper');
          if (select) select.value = 'custom';
          if (selectWrap) selectWrap.classList.add('is-custom');
        }
        updateSummary();
      }
    }, true);

    document.addEventListener('keyup', function (e) {
      var input = (e.target && e.target.classList && e.target.classList.contains('ppc__custom-qty-input')) ? e.target : (e.target && e.target.closest ? e.target.closest('.ppc__custom-qty-input') : null);
      if (input) {
        var row = input.closest('.ppc__colour-row, .ppc__dtf-card');
        if (row) {
          var select = row.querySelector('.ppc__qty-select');
          var selectWrap = row.querySelector('.ppc__select-wrapper');
          if (select) select.value = 'custom';
          if (selectWrap) selectWrap.classList.add('is-custom');
        }
        updateSummary();
      }
    }, true);

    document.addEventListener('change', function (e) {
      var input = (e.target && e.target.classList && e.target.classList.contains('ppc__custom-qty-input')) ? e.target : (e.target && e.target.closest ? e.target.closest('.ppc__custom-qty-input') : null);
      if (input) {
        var row = input.closest('.ppc__colour-row, .ppc__dtf-card');
        if (row) {
          var select = row.querySelector('.ppc__qty-select');
          var selectWrap = row.querySelector('.ppc__select-wrapper');
          if (select) select.value = 'custom';
          if (selectWrap) selectWrap.classList.add('is-custom');
        }
        updateSummary();
      }
    }, true);

    // Root-level event listeners for custom quantity inputs and close button
    root.addEventListener('click', function (e) {
      var closeBtn = e.target.closest('.ppc__cqty-close');
      if (closeBtn) {
        e.preventDefault();
        e.stopPropagation();
        var row = closeBtn.closest('.ppc__colour-row, .ppc__dtf-card');
        if (row) {
          var select = row.querySelector('.ppc__qty-select');
          var selectWrap = row.querySelector('.ppc__select-wrapper');
          var box = row.querySelector('.ppc__custom-qty-box');
          if (select) {
            select.value = '';
            select.style.removeProperty('display');
          }
          if (selectWrap) selectWrap.classList.remove('is-custom');
          if (box) {
            box.classList.remove('is-visible');
            box.style.setProperty('display', 'none', 'important');
          }
          updateSummary();
          toggleRowUpload(row);
          validate();
        }
      }
    });

    // Main image switcher helper
    function updateMainImageForColour(colourName) {
      if (!colourName) return;
      var previewUrl = rowPreviewUrls[colourName];
      if (previewUrl && mainImage) {
        mainImage.src = previewUrl;
        mainImage.hidden = false;
        return;
      }

      if (colourImages && colourImages[colourName] && mainImage) {
        var imgUrl = colourImages[colourName];
        mainImage.src = imgUrl;
        root.querySelectorAll('.ppc__thumb').forEach(function (thumb) {
          if (thumb.getAttribute('data-image-url') === imgUrl) {
            thumb.classList.add('is-active');
          } else {
            thumb.classList.remove('is-active');
          }
        });
      }
    }

    function setActiveRow(colourName) {
      activeRowColour = colourName;
      rows.forEach(function (row) {
        row.classList.toggle('is-active', row.getAttribute('data-colour') === colourName);
      });
      updateMainImageForColour(colourName);
    }

    root.querySelectorAll('.ppc__dtf-card, .ppc__standard-row').forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (e.target.closest('select, input, button, label')) return;
        var colour = card.getAttribute('data-colour');
        if (colour) setActiveRow(colour);
      });
    });

    // Thumbnails click
    root.querySelectorAll('.ppc__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        root.querySelectorAll('.ppc__thumb').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (mainImage) mainImage.src = thumb.getAttribute('data-image-url');
      });
    });

    function updateSummary() {
      var totalQty = 0;
      var totalPrice = 0;
      var colourTotals = {};

      rows.forEach(function (row) {
        var select = row.querySelector('.ppc__qty-select');
        var selectWrap = row.querySelector('.ppc__select-wrapper');
        var customBox = row.querySelector('.ppc__custom-qty-box');
        var customInput = (customBox && customBox.querySelector('.ppc__custom-qty-input')) || row.querySelector('.ppc__custom-qty-input');
        var subtotalEl = row.querySelector('.ppc__row-subtotal');
        var opt = selectedOption(select);
        var colourName = row.getAttribute('data-colour');
        var rowVariants = variantsForRow(row);

        var isCustomMode = !!(select && select.value === 'custom') ||
                           !!(selectWrap && selectWrap.classList.contains('is-custom'));

        if (isCustomMode) {
          if (select) {
            select.value = 'custom';
            select.style.setProperty('display', 'none', 'important');
          }
          if (selectWrap) {
            selectWrap.classList.add('is-custom');
          }
          if (customBox) {
            customBox.classList.add('is-visible');
            customBox.style.setProperty('display', 'inline-flex', 'important');
            customBox.removeAttribute('hidden');
          }
          var valStr = customInput ? String(customInput.value).trim() : '';
          var parsedVal = parseFloat(valStr);
          var customQty = (!isNaN(parsedVal) && parsedVal > 0) ? parsedVal : 1;

          var tierInfo = getTierPriceForRow(row, rowVariants, customQty);
          // Round up to a whole multiple of the base variant's bundle size so the price
          // shown here always matches what the cart will actually charge.
          var effectiveQty = effectiveCustomQty(customQty, tierInfo.bundleQty);
          var rowPrice = effectiveQty * tierInfo.unitPrice;

          totalQty += effectiveQty;
          totalPrice += rowPrice;
          if (subtotalEl) {
            subtotalEl.textContent = formatMoney(rowPrice);
          }
          if (colourName) {
            if (!colourTotals[colourName]) colourTotals[colourName] = { qty: 0, price: 0 };
            colourTotals[colourName].qty += effectiveQty;
            colourTotals[colourName].price += rowPrice;
          }
        } else {
          if (selectWrap) {
            selectWrap.classList.remove('is-custom');
          }
          if (select) {
            select.style.removeProperty('display');
          }
          if (customBox) {
            customBox.classList.remove('is-visible');
            customBox.style.setProperty('display', 'none', 'important');
            customBox.setAttribute('hidden', 'true');
          }
          if (select && select.value && opt) {
            var qty = parseInt(opt.getAttribute('data-qty'), 10) || 0;
            var price = parseFloat(opt.getAttribute('data-price')) || 0;
            totalQty += qty;
            totalPrice += price;
            if (subtotalEl) subtotalEl.textContent = formatMoney(price);
            if (colourName) {
              if (!colourTotals[colourName]) colourTotals[colourName] = { qty: 0, price: 0 };
              colourTotals[colourName].qty += qty;
              colourTotals[colourName].price += price;
            }
          } else if (subtotalEl) {
            subtotalEl.textContent = '';
          }
        }

        var rowHasQty = isCustomMode ? (effectiveQty > 0) : !!(select && select.value && opt);
        row.classList.toggle('has-selection', rowHasQty);
      });

      root.querySelectorAll('.ppc__colour-total').forEach(function (el) {
        var t = colourTotals[el.getAttribute('data-colour-total')];
        var u = t && t.qty === 1 ? unitSingular : unitPlural;
        el.textContent = t ? (t.qty + ' ' + u.toLowerCase() + ' — ' + formatMoney(t.price)) : '';
      });

      var qtyUnitEls = root.querySelectorAll('.ppc__qty-unit');
      var currentUnitLabel = (totalQty === 1 ? unitSingular : unitPlural).toLowerCase() + ' selected';
      qtyUnitEls.forEach(function (el) { el.textContent = currentUnitLabel; });

      summaryQtyEls.forEach(function (el) { el.textContent = String(totalQty); });
      summaryPriceEls.forEach(function (el) { el.textContent = formatMoney(totalPrice); });

      validate();
    }

    function cssEscape(value) {
      return String(value).replace(/(["\\])/g, '\\$1');
    }

    function toggleRowUpload(row) {
      var colourName = row.getAttribute('data-colour');
      var select = row.querySelector('.ppc__qty-select');
      var uploadRow = row.querySelector('.ppc__row-upload');
      var fileInput = row.querySelector('.ppc__row-file-input');
      var dropzoneLabel = row.querySelector('.ppc__dropzone-label');
      var uploadedCard = row.querySelector('.ppc__dtf-uploaded-card');
      var thumbEl = row.querySelector('.ppc__row-file-thumb');

      if (!uploadRow) return;
      var hasQty = !!(select && select.value);

      uploadRow.classList.toggle('is-disabled', !hasQty);
      row.classList.toggle('has-selection', hasQty);
      if (fileInput) fileInput.disabled = !hasQty;

      if (!hasQty) {
        if (fileInput) fileInput.value = '';
        delete rowFiles[colourName];
        delete rowPreviewUrls[colourName];
        if (uploadedCard) uploadedCard.hidden = true;
        if (dropzoneLabel) dropzoneLabel.hidden = false;
        if (thumbEl) { thumbEl.hidden = true; thumbEl.src = ''; }
      }
    }

    rows.forEach(function (row) {
      var select = row.querySelector('.ppc__qty-select');
      if (select) {
        select.addEventListener('change', function () {
          bindCustomInput(row);
          updateSummary();
          toggleRowUpload(row);
          var colourName = row.getAttribute('data-colour');
          if (colourName && select.value) setActiveRow(colourName);
          if (select.value === 'custom') {
            var customInput = row.querySelector('.ppc__custom-qty-input');
            if (customInput) {
              setTimeout(function () { customInput.focus(); customInput.select(); }, 50);
            }
          }
        });
        toggleRowUpload(row);
      }
    });

    function handleRowFileUpload(row, file) {
      var colourName = row.getAttribute('data-colour');
      var input = row.querySelector('.ppc__row-file-input');
      var nameEl = row.querySelector('.ppc__row-file-name');
      var thumbEl = row.querySelector('.ppc__row-file-thumb');
      var dropzoneLabel = row.querySelector('.ppc__dropzone-label');
      var uploadedCard = row.querySelector('.ppc__dtf-uploaded-card');

      if (!file) {
        delete rowFiles[colourName];
        delete rowPreviewUrls[colourName];
        if (input) input.value = '';
        if (nameEl) nameEl.textContent = '';
        if (thumbEl) { thumbEl.hidden = true; thumbEl.src = ''; thumbEl.style.display = 'none'; }
        if (uploadedCard) { uploadedCard.hidden = true; uploadedCard.style.display = 'none'; }
        if (dropzoneLabel) { dropzoneLabel.hidden = false; dropzoneLabel.style.display = ''; }
        validate();
        return;
      }

      if (file.size > maxFileMb * 1024 * 1024) {
        if (errorEl) errorEl.textContent = file.name + ' exceeds max allowed size of ' + maxFileMb + 'MB.';
        handleRowFileUpload(row, null);
        return;
      }

      rowFiles[colourName] = file;
      if (nameEl) nameEl.textContent = file.name + ' (' + formatFileSize(file.size) + ')';
      if (dropzoneLabel) { dropzoneLabel.hidden = true; dropzoneLabel.style.display = 'none'; }
      if (uploadedCard) { uploadedCard.hidden = false; uploadedCard.style.display = 'flex'; }

      if (/\.(png|jpe?g|gif|webp)$/i.test(file.name)) {
        var reader = new FileReader();
        reader.onload = function (e) {
          rowPreviewUrls[colourName] = e.target.result;
          if (thumbEl) { thumbEl.src = e.target.result; thumbEl.hidden = false; thumbEl.style.display = 'block'; }
          setActiveRow(colourName);
        };
        reader.readAsDataURL(file);
      } else {
        delete rowPreviewUrls[colourName];
        if (thumbEl) { thumbEl.hidden = true; thumbEl.src = ''; thumbEl.style.display = 'none'; }
      }

      validate();
    }

    // Attach File Input & Dropzone handlers for each row
    root.querySelectorAll('.ppc__dtf-card').forEach(function (row) {
      var input = row.querySelector('.ppc__row-file-input');
      var dropzone = row.querySelector('.ppc__dropzone-label');
      var changeBtn = row.querySelector('.ppc__dtf-file-change-btn');
      var removeBtn = row.querySelector('.ppc__dtf-file-remove-btn');
      var uploadedCard = row.querySelector('.ppc__dtf-uploaded-card');
      var thumbEl = row.querySelector('.ppc__row-file-thumb');

      // Ensure clean initial state (no file by default)
      if (uploadedCard) { uploadedCard.hidden = true; uploadedCard.style.display = 'none'; }
      if (dropzone) { dropzone.hidden = false; dropzone.style.display = ''; }
      if (thumbEl) { thumbEl.hidden = true; thumbEl.src = ''; thumbEl.style.display = 'none'; }
      if (input) input.value = '';

      if (input) {
        input.addEventListener('change', function () {
          var file = input.files && input.files[0];
          handleRowFileUpload(row, file);
        });
      }

      if (changeBtn && input) {
        changeBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          input.click();
        });
      }

      if (removeBtn) {
        removeBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          e.preventDefault();
          handleRowFileUpload(row, null);
        });
      }

      if (dropzone) {
        ['dragenter', 'dragover'].forEach(function (eventName) {
          dropzone.addEventListener(eventName, function (e) {
            e.preventDefault();
            dropzone.classList.add('is-dragover');
          });
        });
        ['dragleave', 'drop'].forEach(function (eventName) {
          dropzone.addEventListener(eventName, function (e) {
            e.preventDefault();
            dropzone.classList.remove('is-dragover');
          });
        });
        dropzone.addEventListener('drop', function (e) {
          var dt = e.dataTransfer;
          var files = dt && dt.files;
          if (files && files.length) {
            handleRowFileUpload(row, files[0]);
          }
        });
      }
    });

    // Root-level click delegation for remove buttons
    root.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('.ppc__dtf-file-remove-btn');
      if (removeBtn) {
        e.preventDefault();
        e.stopPropagation();
        var row = removeBtn.closest('.ppc__colour-row--dtf, .ppc__dtf-card');
        if (row) {
          handleRowFileUpload(row, null);
        }
      }
    });

    function removePreview(position) {
      var existing = previewStage && previewStage.querySelector('[data-preview-position="' + cssEscape(position) + '"]');
      if (existing) existing.remove();
    }

    // Print position toggles
    root.querySelectorAll('.ppc__position-checkbox').forEach(function (checkbox) {
      var position = checkbox.getAttribute('data-position');
      if (checkbox.checked) {
        activePositions[position] = true;
      }
      checkbox.addEventListener('change', function () {
        activePositions[position] = checkbox.checked;
        var uploadRow = root.querySelector('.ppc__upload-row[data-position="' + cssEscape(position) + '"]');
        var fileInput = root.querySelector('.ppc__file-input[data-position="' + cssEscape(position) + '"]');
        if (uploadRow) uploadRow.classList.toggle('is-disabled', !checkbox.checked);
        if (fileInput) {
          fileInput.disabled = !checkbox.checked;
          if (!checkbox.checked) {
            fileInput.value = '';
            delete uploadedFiles[position];
            removePreview(position);
            var nameEl = root.querySelector('.ppc__file-name[data-position="' + cssEscape(position) + '"]');
            if (nameEl) nameEl.textContent = '';
          }
        }
        validate();
      });
    });

    root.querySelectorAll('.ppc__file-input').forEach(function (input) {
      input.addEventListener('change', function () {
        var position = input.getAttribute('data-position');
        var file = input.files && input.files[0];
        var nameEl = root.querySelector('.ppc__file-name[data-position="' + cssEscape(position) + '"]');

        if (!file) {
          delete uploadedFiles[position];
          removePreview(position);
          if (nameEl) nameEl.textContent = '';
          validate();
          return;
        }

        if (file.size > maxFileMb * 1024 * 1024) {
          if (errorEl) errorEl.textContent = file.name + ' exceeds max size of ' + maxFileMb + 'MB.';
          input.value = '';
          delete uploadedFiles[position];
          removePreview(position);
          if (nameEl) nameEl.textContent = '';
          validate();
          return;
        }

        uploadedFiles[position] = file;
        if (nameEl) nameEl.textContent = file.name + ' (' + formatFileSize(file.size) + ')';

        if (/\.(png|jpe?g|gif|webp)$/i.test(file.name) && previewStage) {
          var reader = new FileReader();
          reader.onload = function (e) {
            removePreview(position);
            var img = document.createElement('img');
            img.setAttribute('data-preview-position', position);
            var area = printAreas[position];
            if (area) {
              img.style.left = area.x + '%';
              img.style.top = area.y + '%';
              img.style.width = area.width + '%';
              img.style.height = area.height + '%';
            } else {
              img.style.left = '35%';
              img.style.top = '25%';
              img.style.width = '30%';
              img.style.height = '25%';
            }
            img.src = e.target.result;
            previewStage.appendChild(img);
          };
          reader.readAsDataURL(file);
        }

        validate();
      });
    });

    function validate(showAllErrors) {
      var showErrors = Boolean(showAllErrors);
      var totalQty = 0;
      rows.forEach(function (row) {
        var select = row.querySelector('.ppc__qty-select');
        var customInput = row.querySelector('.ppc__custom-qty-input');
        if (select && select.value === 'custom') {
          totalQty += parseInt(customInput ? customInput.value : '1', 10) || 0;
        } else if (select && select.value) {
          var opt = selectedOption(select);
          if (opt) totalQty += parseInt(opt.getAttribute('data-qty'), 10) || 0;
        }
      });

      var configType = root.getAttribute('data-config-type') || 'standard';
      var missingUploads = [];
      var missingRowUploads = [];

      if (configType === 'dtf') {
        if (artworkMode === 'shared') {
          if (totalQty > 0 && !masterFile) {
            missingUploads.push('Master Artwork for all sizes');
          }
        } else {
          rows.forEach(function (row) {
            if (!row.querySelector('.ppc__row-file-input')) return;
            var colourName = row.getAttribute('data-colour');
            var select = row.querySelector('.ppc__qty-select');
            if (select && select.value && !rowFiles[colourName]) missingRowUploads.push(colourName);
          });
        }
      } else if (configType !== 'photo') {
        // Standard custom apparel & merchandise (T-Shirts, Polos, Caps, Badges, Keychains, Mousepads, etc.)
        var checkedPositions = Object.keys(activePositions).filter(function (p) {
          return activePositions[p];
        });

        if (checkedPositions.length === 0) {
          missingUploads.push('at least one print position and upload your artwork');
        } else {
          checkedPositions.forEach(function (pos) {
            if (!uploadedFiles[pos]) {
              var posLabel = pos.replace(/-/g, ' ');
              posLabel = posLabel.charAt(0).toUpperCase() + posLabel.slice(1);
              missingUploads.push(posLabel + ' Artwork');
            }
          });
        }

        if (checkedPositions.length > 0 && Object.keys(uploadedFiles).length === 0) {
          if (missingUploads.length === 0) {
            missingUploads.push('your design / logo artwork');
          }
        }
      }

      var message = '';
      if (totalQty === 0) {
        message = 'Please choose a quantity for at least one size.';
      } else if (missingUploads.length > 0) {
        message = 'Please upload: ' + missingUploads.join(', ');
      } else if (missingRowUploads.length > 0) {
        message = 'Please upload a gang sheet / design for: ' + missingRowUploads.join(', ');
      }

      var hasError = (totalQty === 0 || missingUploads.length > 0 || missingRowUploads.length > 0);

      if (errorEl) {
        if (showErrors) {
          errorEl.textContent = message;
        } else {
          errorEl.textContent = (totalQty > 0 && (missingUploads.length > 0 || missingRowUploads.length > 0)) ? message : '';
        }
      }
      if (submitBtn) {
        submitBtn.setAttribute('aria-disabled', hasError ? 'true' : 'false');
        submitBtn.classList.toggle('is-disabled', hasError);
        if (!hasError) {
          submitBtn.disabled = false;
        }
      }
      return !hasError;
    }

    function buildSharedProperties() {
      var props = {};
      var checkedPositions = Object.keys(activePositions).filter(function (p) { return activePositions[p]; });
      if (checkedPositions.length) props['Print Positions'] = checkedPositions.join(', ');

      if (notes && notes.value.trim()) props['Order Notes'] = notes.value.trim();

      props['_bundle_id'] = 'ppc-' + Date.now();
      return props;
    }

    function collectSelectedLines() {
      var lines = [];
      rows.forEach(function (row) {
        var select = row.querySelector('.ppc__qty-select');
        var customInput = row.querySelector('.ppc__custom-qty-input');
        if (select && select.value) {
          var colourName = row.getAttribute('data-colour') || '';
          var sizeName = row.getAttribute('data-size');
          var colourImg = (colourImages && colourName) ? (colourImages[colourName] || '') : '';
          var rowVariants = variantsForRow(row);

          if (select.value === 'custom') {
            var customQty = parseFloat(customInput ? customInput.value : '1') || 1;
            var tierInfo = getTierPriceForRow(row, rowVariants, customQty);
            // The base variant may represent a bundle of several pieces (e.g. "2 Pcs
            // Sample"), and Shopify charges variant.price * cart quantity — so the
            // cart quantity must be a bundle count, not a raw piece count, or the
            // customer gets charged bundleQty times too much. displayQty (real pieces,
            // rounded up to a whole bundle) is what shows in the "Custom Quantity"
            // property; quantity (bundles) is what actually gets added to the cart.
            var effectiveQty = effectiveCustomQty(customQty, tierInfo.bundleQty);
            var bundles = tierInfo.bundleQty > 0 ? (effectiveQty / tierInfo.bundleQty) : effectiveQty;
            lines.push({
              id: tierInfo.variantId,
              quantity: bundles,
              displayQty: effectiveQty,
              isCustomQty: true,
              unitRate: formatMoney(tierInfo.unitPrice),
              colour: colourName,
              size: sizeName,
              colourImg: colourImg,
              rowFile: rowFiles[colourName] || null
            });
          } else {
            lines.push({
              id: parseInt(select.value, 10),
              quantity: 1,
              isCustomQty: false,
              colour: colourName,
              size: sizeName,
              colourImg: colourImg,
              rowFile: rowFiles[colourName] || null
            });
          }
        }
      });
      return lines;
    }

    async function submitOrder() {
      triggerShake(submitBtn);

      var isValid = validate(true);
      if (!isValid) {
        if (errorEl) {
          triggerShake(errorEl);
        }
        var uploadCard = root.querySelector('.ppc__card--positions, .ppc__master-upload, .ppc__uploads');
        if (uploadCard && typeof uploadCard.scrollIntoView === 'function') {
          uploadCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }

      var lines = collectSelectedLines();
      if (!lines.length) {
        if (errorEl) {
          errorEl.textContent = 'Please choose a quantity for at least one size.';
          triggerShake(errorEl);
        }
        return;
      }

      var sharedProps = buildSharedProperties();
      var fileEntries = Object.keys(uploadedFiles).map(function (position) {
        return { position: position, file: uploadedFiles[position] };
      });

      // Strict check: Custom apparel MUST have at least one uploaded file!
      var configType = root.getAttribute('data-config-type') || 'standard';
      if (configType === 'dtf') {
        if (artworkMode === 'shared' && !masterFile) {
          if (errorEl) {
            errorEl.textContent = 'Please upload: Master Artwork for all sizes';
            triggerShake(errorEl);
          }
          return;
        }
      } else if (configType !== 'photo') {
        if (fileEntries.length === 0) {
          if (errorEl) {
            errorEl.textContent = 'Please upload your design / logo artwork before adding to cart.';
            triggerShake(errorEl);
          }
          var posCard = root.querySelector('.ppc__card--positions, .ppc__uploads');
          if (posCard && typeof posCard.scrollIntoView === 'function') {
            posCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          return;
        }
      }

      submitBtn.disabled = true;
      statusEl.textContent = 'Adding to cart…';

      try {
        if (lines.some(function (l) { return l.rowFile; }) || (masterFile && artworkMode === 'shared')) {
          for (var i = 0; i < lines.length; i++) {
            var line = lines[i];
            var lineProps = Object.assign({}, sharedProps);
            if (line.colour) lineProps['Size'] = line.colour;
            if (line.colourImg) lineProps['_color_img'] = line.colourImg;
            if (line.isCustomQty) {
              lineProps['Custom Quantity'] = line.displayQty + ' ' + (line.displayQty === 1 ? unitSingular.toLowerCase() : unitPluralLower);
              lineProps['Tier Unit Rate'] = line.unitRate + '/' + unitLower;
            }

            var rowFormData = new FormData();
            rowFormData.append('id', line.id);
            rowFormData.append('quantity', line.quantity || 1);
            Object.keys(lineProps).forEach(function (key) {
              rowFormData.append('properties[' + key + ']', lineProps[key]);
            });
            var fileToSend = (artworkMode === 'shared') ? masterFile : line.rowFile;
            if (fileToSend) {
              rowFormData.append('properties[Design]', fileToSend, fileToSend.name);
            }

            var rowRes = await fetch(cartAddUrl, { method: 'POST', body: rowFormData });
            if (!rowRes.ok) throw new Error('Failed to add ' + line.colour + ' to cart');
          }
        } else if (fileEntries.length) {
          var firstLine = lines[0];
          var restLines = lines.slice(1);

          var firstProps = Object.assign({}, sharedProps);
          if (firstLine.colourImg) firstProps['_color_img'] = firstLine.colourImg;
          if (firstLine.isCustomQty) {
            firstProps['Custom Quantity'] = firstLine.displayQty + ' ' + (firstLine.displayQty === 1 ? unitSingular.toLowerCase() : unitPluralLower);
            firstProps['Tier Unit Rate'] = firstLine.unitRate + '/' + unitLower;
          }

          var formData = new FormData();
          formData.append('id', firstLine.id);
          formData.append('quantity', firstLine.quantity || 1);
          Object.keys(firstProps).forEach(function (key) {
            formData.append('properties[' + key + ']', firstProps[key]);
          });
          fileEntries.forEach(function (entry) {
            formData.append('properties[' + entry.position + ' Artwork]', entry.file, entry.file.name);
          });

          var firstRes = await fetch(cartAddUrl, { method: 'POST', body: formData });
          if (!firstRes.ok) throw new Error('Failed to add primary line');

          var artworkUrls = {};
          try {
            var firstJson = await firstRes.clone().json();
            var itemProps = (firstJson.items && firstJson.items[0] && firstJson.items[0].properties)
              || firstJson.properties || {};
            Object.keys(itemProps).forEach(function (k) {
              var v = String(itemProps[k] || '');
              if (v.indexOf('/uploads/') !== -1 || v.indexOf('cdn.shopify') !== -1) {
                artworkUrls[k] = v;
              }
            });
          } catch (e) { }

          if (restLines.length) {
            var restItems = restLines.map(function (line) {
              var lineProps = Object.assign({}, sharedProps);
              if (line.colourImg) lineProps['_color_img'] = line.colourImg;
              if (line.isCustomQty) {
                lineProps['Custom Quantity'] = line.displayQty + ' ' + (line.displayQty === 1 ? unitSingular.toLowerCase() : unitPluralLower);
                lineProps['Tier Unit Rate'] = line.unitRate + '/' + unitLower;
              }
              if (Object.keys(artworkUrls).length) {
                Object.keys(artworkUrls).forEach(function (k) {
                  lineProps['_artwork_ref_' + k] = artworkUrls[k];
                });
              } else {
                lineProps['_artwork_ref'] = 'See first item in this bundle for artwork files';
              }
              return { id: line.id, quantity: line.quantity || 1, properties: lineProps };
            });
            var restRes = await fetch(cartAddUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: restItems })
            });
            if (!restRes.ok) throw new Error('Failed to add remaining lines');
          }
        } else {
          var items = lines.map(function (line) {
            var lineProps = Object.assign({}, sharedProps);
            if (line.colourImg) lineProps['_color_img'] = line.colourImg;
            if (line.isCustomQty) {
              lineProps['Custom Quantity'] = line.displayQty + ' ' + (line.displayQty === 1 ? unitSingular.toLowerCase() : unitPluralLower);
              lineProps['Tier Unit Rate'] = line.unitRate + '/' + unitLower;
            }
            return { id: line.id, quantity: line.quantity || 1, properties: lineProps };
          });
          var res = await fetch(cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          });
          if (!res.ok) throw new Error('Failed to add to cart');
        }

        statusEl.textContent = 'Added to cart!';
        if (typeof ajaxCart !== 'undefined' && typeof ajaxCart.load === 'function') {
          try { ajaxCart.load(); } catch (e) {}
        }
        if (window.dTGeneral && typeof window.dTGeneral.showMiniCart === 'function') {
          try {
            if (typeof window.dTGeneral.closeMiniCart === 'function') window.dTGeneral.closeMiniCart();
            window.dTGeneral.showMiniCart();
          } catch (e) {}
        }
      } catch (err) {
        statusEl.textContent = '';
        errorEl.textContent = 'Something went wrong adding this to your cart. Please try again.';
      } finally {
        submitBtn.disabled = false;
      }
    }

    if (submitBtn) submitBtn.addEventListener('click', submitOrder);

    var waBtn = root.querySelector('.ppc__whatsapp-btn');
    if (waBtn) {
      waBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var rawPhone = waBtn.getAttribute('data-phone') || '9211537151';
        var cleanPhone = rawPhone.replace(/\D/g, '');
        if (cleanPhone.length === 10) cleanPhone = '91' + cleanPhone;
        if (!cleanPhone) cleanPhone = '919211537151';

        var greeting = waBtn.getAttribute('data-greeting') || 'Hello My Print Warrior, I would like to order:';
        var productTitle = waBtn.getAttribute('data-product-title') || document.title;
        var pageUrl = window.location.href;

        var selectedLines = [];
        var totalUnits = 0;
        var totalCost = 0;

        rows.forEach(function (row) {
          var select = row.querySelector('.ppc__qty-select');
          var customInput = row.querySelector('.ppc__custom-qty-input');
          var colourName = row.getAttribute('data-colour') || '';
          var sizeName = row.getAttribute('data-size') || '';

          if (select && select.value) {
            var label = colourName ? (sizeName ? (colourName + ' (' + sizeName + ')') : colourName) : (sizeName || 'Standard');
            if (select.value === 'custom') {
              var cQty = parseInt(customInput ? customInput.value : '1', 10) || 1;
              var rowVariants = variantsForRow(row);
              var tier = getTierPriceForRow(row, rowVariants, cQty);
              var effQty = effectiveCustomQty(cQty, tier.bundleQty);
              var price = effQty * tier.unitPrice;
              totalUnits += effQty;
              totalCost += price;
              selectedLines.push(' • ' + label + ': ' + effQty + ' ' + (effQty === 1 ? unitSingular : unitPlural).toLowerCase());
            } else {
              var opt = selectedOption(select);
              var q = parseInt(opt.getAttribute('data-qty'), 10) || 0;
              var p = parseFloat(opt.getAttribute('data-price')) || 0;
              totalUnits += q;
              totalCost += p;
              selectedLines.push(' • ' + label + ': ' + q + ' ' + (q === 1 ? unitSingular : unitPlural).toLowerCase());
            }
          }
        });

        var checkedPositions = Object.keys(activePositions).filter(function (p) { return activePositions[p]; });
        var noteVal = notes && notes.value ? notes.value.trim() : '';

        var msgParts = [greeting, '', '📦 *Product:* ' + productTitle];

        if (selectedLines.length > 0) {
          msgParts.push('', '📋 *Selected Items:*');
          msgParts.push(selectedLines.join('\n'));
          msgParts.push('🔢 *Total Quantity:* ' + totalUnits + ' ' + (totalUnits === 1 ? unitSingular : unitPlural).toLowerCase());
          msgParts.push('💰 *Estimated Total:* ' + formatMoney(totalCost));
        }

        if (checkedPositions.length > 0) {
          msgParts.push('🎨 *Print Positions:* ' + checkedPositions.join(', '));
        }

        if (noteVal) {
          msgParts.push('📝 *Notes:* ' + noteVal);
        }

        msgParts.push('', '🔗 *Link:* ' + pageUrl);
        msgParts.push('', 'Please confirm availability and how to proceed!');

        var waUrl = 'https://api.whatsapp.com/send?phone=' + cleanPhone + '&text=' + encodeURIComponent(msgParts.join('\n'));
        window.open(waUrl, '_blank');
      });
    }

    updateSummary();
  }

  function initStickyGallery(root) {
    var gallery = root.querySelector('.ppc__gallery');
    var inner = root.querySelector('.ppc__inner');
    if (!gallery || !inner) return;

    var placeholder = document.createElement('div');
    placeholder.setAttribute('aria-hidden', 'true');
    placeholder.style.display = 'none';
    gallery.parentNode.insertBefore(placeholder, gallery.nextSibling);

    var topOffset = 24;
    var state = 'static';
    var metrics = null;

    function applyState() {
      gallery.classList.remove('ppc__gallery--pinned', 'ppc__gallery--bottom');

      if (state === 'pinned') {
        gallery.style.position = 'fixed';
        gallery.style.top = topOffset + 'px';
        gallery.style.left = metrics.left + 'px';
        gallery.style.width = metrics.width + 'px';
        gallery.classList.add('ppc__gallery--pinned');
        placeholder.style.display = 'block';
      } else if (state === 'bottom') {
        gallery.style.position = 'absolute';
        gallery.style.top = (inner.offsetHeight - metrics.height) + 'px';
        gallery.style.left = '0px';
        gallery.style.width = metrics.width + 'px';
        gallery.classList.add('ppc__gallery--bottom');
        placeholder.style.display = 'block';
      } else {
        gallery.style.position = '';
        gallery.style.top = '';
        gallery.style.left = '';
        gallery.style.width = '';
        placeholder.style.display = 'none';
      }
    }

    function measure() {
      var wasActive = state !== 'static';
      if (wasActive) {
        state = 'static';
        applyState();
      }
      var rect = gallery.getBoundingClientRect();
      metrics = { left: rect.left, width: rect.width, height: rect.height };
      placeholder.style.width = metrics.width + 'px';
      placeholder.style.height = metrics.height + 'px';
    }

    function update() {
      if (window.innerWidth <= 991 || !metrics) {
        if (state !== 'static') { state = 'static'; applyState(); }
        return;
      }

      var innerRect = inner.getBoundingClientRect();
      var newState;
      if (innerRect.top > topOffset) {
        newState = 'static';
      } else if (innerRect.bottom - metrics.height < topOffset) {
        newState = 'bottom';
      } else {
        newState = 'pinned';
      }

      if (newState !== state) {
        state = newState;
        applyState();
      }
    }

    function onResize() {
      measure();
      update();
    }

    measure();
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', onResize);
  }

  function init() {
    document.querySelectorAll('.ppc').forEach(function (root) {
      // The DTF per-metre sheet builder has its own script (dtf-sheet-builder.js)
      if (root.getAttribute('data-config-type') !== 'dtf-sheet') initPPC(root);
      initStickyGallery(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Global shake effect on clicking any Add to Cart button
  if (typeof document !== 'undefined') {
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('.ppc__add-to-cart, .dT_AddToCart, .dT_AddToCartBtn, button[name="add"], .product-form__submit');
      if (btn) {
        triggerShake(btn);
      }
    }, true);
  }
})();
